<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
          <Commondropdownlist ref="UserLoginLogRef" :lablewith="item.lablewith" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup :qhide="false" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <div>
          <Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export" :src="require('@/assets/icon/daoc.png')">
          </Commonbtn>
        </div>
        <!-- style="border: 1px solid blue;" -->
        <div class="TableWidth">
          <Commontable :loadingTable="loadingTable" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
          </Commontable>
          <div class="pagination">
            <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total" :pageSize="pageSize"></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '@/components/common-dropdownlist.vue'
import CommonBtngroup from '@/components/commongroup.vue'
import Dialog from '@/components/dialog.vue'
import Commontable from '@/components/common-table.vue'
import Commonbtn from '@/components/common-btn.vue'
import Pagination from '@/components/pagination.vue'
import utils from '@/common/utils'
import formdata from './FormData/formdata'
import headerData from './headerData/index'
import {
  HelperUserLoginLogList,
  HelperUserLoginLogExport
} from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Dialog,
    Commontable,
    Commonbtn,
    Pagination
  },
  data() {
    return {
      total: 1,
      pageindex: 1,
      pageSize: 10,
      tableData: [],
      headerData: [],
      dialogVisibles: false,
      loadingTable: false,
      showorhide: true,
      formdata: [],
      from: {
        UserName: "",
        TrueName: "",
        CreateTime1: "",
        CreateTime2: "",

      }
    }
  },
  mounted() {
    this.formdata = JSON.parse(JSON.stringify(formdata));
    this.headerData = JSON.parse(JSON.stringify(headerData));
    this.HelperUserLoginLogList();
  },
  computed: {
  },
  methods: {
    // 列表
    async HelperUserLoginLogList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });

      let {
        data,
        code
      } = await HelperUserLoginLogList({
        UserName: this.from.UserName,
        TrueName: this.from.TrueName,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
        }
        loading.close();
      }
      loading.close();
    },
    // 导出
    async HelperUserLoginLogExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let resexprot = await HelperUserLoginLogExport({
        UserName: this.from.UserName,
        TrueName: this.from.TrueName,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (resexprot) {
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `用户登录记录${str}`, "xlsx")
        loading.close();
      } else {
        // 返回json
        this.$message.warning('导出失败');
        loading.close();
      }
      loading.close()
    },
    // 导出
    Export() {
      this.HelperUserLoginLogExport()
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.HelperUserLoginLogList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.HelperUserLoginLogList()
    },
    select() {
      this.pageindex = 1
      try {
        this.from.UserName = this.$refs.UserLoginLogRef[0].modelvalue
        this.from.TrueName = this.$refs.UserLoginLogRef[1].modelvalue
        this.from.CreateTime1 = this.$refs.UserLoginLogRef[2].startTime
        this.from.CreateTime2 = this.$refs.UserLoginLogRef[2].endTime
        this.HelperUserLoginLogList()
      } catch (error) {
        this.HelperUserLoginLogList()
      }
    },
    reset() {
      this.$refs.UserLoginLogRef.map((item, index) => {
        if(index == 2) {
          item.startTime = '';
          item.endTime = '';
        }
        item.modelvalue = "";
      })
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 12px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 10px;
  width: 340px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 48px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 20px;
}
</style>